'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layer = exports.tabQBUrl = exports.articleShareUrl = exports.galleryQBUrl = exports.galleryUrl = exports.buildArticleQBUrl = exports.buildAttachUrl = exports.buildArticleUrl = undefined;

var _tag = require('./tag');

Object.keys(_tag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _tag[key];
    }
  });
});

var _official = require('./official');

Object.keys(_official).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _official[key];
    }
  });
});

var _circle = require('./circle');

Object.keys(_circle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _circle[key];
    }
  });
});

var _fusion = require('./fusion');

Object.keys(_fusion).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fusion[key];
    }
  });
});

var _buildArticleQBUrl = require('./buildArticleQBUrl');

var _buildArticleQBUrl2 = _interopRequireDefault(_buildArticleQBUrl);

var _buildArticleUrl = require('./buildArticleUrl');

var _buildArticleUrl2 = _interopRequireDefault(_buildArticleUrl);

var _buildAttachUrl = require('./buildAttachUrl');

var _buildAttachUrl2 = _interopRequireDefault(_buildAttachUrl);

var _galleryUrl = require('./galleryUrl');

var _galleryUrl2 = _interopRequireDefault(_galleryUrl);

var _galleryQBUrl = require('./galleryQBUrl');

var _galleryQBUrl2 = _interopRequireDefault(_galleryQBUrl);

var _Layer = require('./Layer');

var _Layer2 = _interopRequireDefault(_Layer);

var _articleShareUrl = require('./articleShareUrl');

var _articleShareUrl2 = _interopRequireDefault(_articleShareUrl);

var _tabQBUrl = require('./tabQBUrl');

var _tabQBUrl2 = _interopRequireDefault(_tabQBUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * @Author: edvardchen
 * @Date:   2016-08-15 19:36:43
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2019-05-17 15:05:43
 */
exports.buildArticleUrl = _buildArticleUrl2.default;
exports.buildAttachUrl = _buildAttachUrl2.default;
exports.buildArticleQBUrl = _buildArticleQBUrl2.default;
exports.galleryUrl = _galleryUrl2.default;
exports.galleryQBUrl = _galleryQBUrl2.default;
exports.articleShareUrl = _articleShareUrl2.default;
exports.tabQBUrl = _tabQBUrl2.default;
exports.Layer = _Layer2.default;